import Vue from 'vue'
import * as Sentry from '@sentry/vue'

let initialized = false

export function captureException (err, { tags } = {}) {
  if (!initialized) return
  Sentry.withScope(scope => {
    if (tags) scope.setTags(tags)
    scope.captureException(err)
  })
}

export function setUser (user) {
  if (!initialized) return
  Sentry.setUser(user)
}

export function setTag (key, value) {
  if (!initialized) return
  Sentry.setTag(key, value)
}

export function setTags (tags) {
  if (!initialized) return
  Sentry.setTags(tags)
}

export function setContext (key, context) {
  if (!initialized) return
  Sentry.setContext(key, context)
}

export const logger = Sentry.logger

// onError 录制模式下，在关键节点主动 flush buffer，保留这段无错误的回放
export function flushReplay () {
  if (!initialized) return
  try {
    const replay = Sentry.getReplay()
    replay && replay.flush()
  } catch (e) {
    console.error('flushReplay error', e)
  }
}

export function stopReplay () {
  if (!initialized) return
  Sentry.getReplay()?.stop()
}

export default function sentryInstall ({ router, dsn, platform }) {
  if (process.env.NODE_ENV !== 'production') return

  Sentry.init({
    Vue,
    dsn,
    release: `${platform}@${process.env.ver}`,
    environment: 'production',
    initialScope: {
      tags: { platform },
    },
    tracePropagationTargets: [
      'localhost',
      'https://api.jyb.com.tw/',
      'https://apisp.jyb.com.tw/',
    ],
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: true,
        networkDetailAllowUrls: [
          window.location.origin,
          'api.jyb.com.tw',
          'apisp.jyb.com.tw',
          'v0.api.upyun.com/jyb-tsmd',
        ],
        networkCaptureBodies: true,
        // 记录 axiosProvider 请求拦截器加的自定义头，便于对后端日志与内嵌包版本；Authorization 刻意不录
        networkRequestHeaders: ['Tsmd-Site', 'H5-Ver', 'Pc-Ver', 'Req-Id'],
      }),
      Sentry.elementTimingIntegration(),
      Sentry.viewHierarchyIntegration(),
    ],
    tracesSampleRate: 0.1,
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1,
    enableLogs: true,
    ignoreErrors: [
      'APPonAirHtmlBatchController',
      'Decoding failed',
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      'Non-Error promise rejection captured',
      'Network Error',
    ],
  })

  initialized = true
}
